import { render, staticRenderFns } from "./bimTextMedium.vue?vue&type=template&id=0f65208b&scoped=true&lang=html&"
import script from "./bimTextMedium.vue?vue&type=script&lang=js&"
export * from "./bimTextMedium.vue?vue&type=script&lang=js&"
import style0 from "./bimTextMedium.vue?vue&type=style&index=0&id=0f65208b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f65208b",
  null
  
)

export default component.exports